import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Select from "react-select"
import Button from "@material-ui/core/Button"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class TirdparyUseforPrice extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  thirdpartyPriceUseforState: this.props.thirdpartyPriceUsefor,
                  selectedThirdpartyUsefor: {
                        value: this.props.thirdpartyPriceUsefor.thirdpartyprice_usefor_usefor_id,
                        label: this.props.thirdpartyPriceUsefor.thirdparty_usefor_name,
                  },
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  optionThirdpartyUsefor: [],
            }
      }
      componentDidMount() {
            this.getoptionThirdpartyUsefor()
      }

      getoptionThirdpartyUsefor = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].usefor_id, label: arr.data[k].usefor_name })
                              }
                              self.setState({ optionThirdpartyUsefor: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_usefor")
            fd.append("carmode_id", this.props.thirdparty_price_car_mode_id)
            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.send(fd)
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleInstalmentMode = (selectedThirdpartyUsefor) => {
            var temparray = this.state.thirdpartyPriceUseforState
            temparray.thirdpartyprice_usefor_usefor_id = selectedThirdpartyUsefor.value
            this.setState({ selectedThirdpartyUsefor: selectedThirdpartyUsefor, thirdpartyPriceUseforState: temparray })
      }

      handleChangeConditionsPercent = (event) => {
            var temparray = this.state.thirdpartyPriceUseforState
            temparray.thirdpartyprice_usefor_percent = event.target.value
            this.setState({ thirdpartyPriceUseforState: temparray })
      }

      modifyNewInstalmentCondition = () => {
            const { thirdpartyPriceUseforState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_price_usefor")
            fd.append("thirdpartyprice_usefor_id", thirdpartyPriceUseforState.thirdpartyprice_usefor_id)
            fd.append("thirdpartyprice_usefor_percent", thirdpartyPriceUseforState.thirdpartyprice_usefor_percent)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deleteInstalmentCondition = () => {
            const { thirdpartyPriceUseforState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_price_usefor")
            fd.append("thirdpartyprice_usefor_id", thirdpartyPriceUseforState.thirdpartyprice_usefor_id)

            xhttp.open("POST", `${constants.BASE_URL}/thirdparty`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const {
                  optionThirdpartyUsefor,
                  snackMode,
                  snackstr,
                  showSnack,
                  visible,
                  selectedThirdpartyUsefor,
                  thirdpartyPriceUseforState,
            } = this.state
            if (visible) {
                  return (
                        <Grid container spacing={3}>
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>

                              <Grid item xs={5}>
                                    <div>
                                          <label className="on"> مورد استفاده بیمه نامه </label>
                                          <Select
                                                isSearchable={true}
                                                className="adapter-txtsize"
                                                placeholder={"مورد استفاده بیمه نامه  "}
                                                value={selectedThirdpartyUsefor}
                                                onChange={this.handleInstalmentMode}
                                                options={optionThirdpartyUsefor}
                                          />
                                    </div>
                              </Grid>

                              <Grid item xs={4}>
                                    <FloatingLabelInput
                                          placeholder="درصد حق بیمه"
                                          handleInputt={this.handleChangeConditionsPercent}
                                          value={thirdpartyPriceUseforState.thirdpartyprice_usefor_percent}
                                    />
                              </Grid>

                              <Grid item xs={3}>
                                    <div style={{ width: "100%", textAlign: "left" }}>
                                          <Fab
                                                className={classes.small}
                                                style={{ background: "#44b700" }}
                                                aria-label="edit"
                                                onClick={this.modifyNewInstalmentCondition}
                                          >
                                                <EditIcon />
                                          </Fab>

                                          <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                                <DeleteIcon />
                                          </Fab>
                                    </div>
                              </Grid>
                              <Grid item xs={12}>
                                    <Divider />
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(TirdparyUseforPrice)
